import ListController from '@/core/ListController';
import { report } from '@/helpers/reports';

export default class InvoiceRequirementsListController extends ListController {
    public activeTab: string = 'all';

    constructor(public name: string, public params: any = {}, public grid: any = null) {
        super(name, params);
    }

    setup() {
        const setup = super.setup();
        
        if (setup.config) {
            setup.config.localStorageKey = 'invoice_requirements_grid_settings';
            setup.config.sorting = true;
        }
        
        return setup;
    }

    setButtons() {
        const grid = this.grid?.value;
        if (!grid || !grid.controller) return;

        const panelFun: any = [];
        panelFun.push(
            {
                edit: this.store.accessRead() ? {} : null,
                add: this.store.accessCreate() ? {} : null,
                copy: this.store.accessCreate() ? {} : null,
                delete: this.store.accessDelete() ? {} : null,
            }
        );

        const isPendingTab = this.activeTab === 'pending';
        panelFun.push({
            print: {
                caption: 'Печать',
                title: isPendingTab ? 'Печать реестра заявок' : 'Печать реестра накладных-требований',
                icon: <i class="icon icon-printer"></i>,
                class: 'btn btn-outline-secondary',
                onClick: () => report(
                    isPendingTab ? 'Реестр заявок' : 'Реестр накладных-требований',
                    'nsi.invoice_requirements_list_print',
                    { tab: isPendingTab ? 'pending' : 'all' }
                )
            }
        });

        grid.controller.createPanelFun(panelFun);
    }
}
